/*  Shared  */
import { getDateTime } from 'application/Shared/Components/Core';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { useEffect, useState } from 'react';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

const BreachPicker = (props) => {
    const loadIncidents = async ({ setLoaded, setObjectPayload }) => {
        let response;
        setLoaded(false);
        try {
            const { CancelToken } = axios;
            const source = CancelToken.source();
            response = await axios.get('/breach', {
                cancelToken: source.token,
                params: {
                    includeApplication: true,
                    order: 'DESC',
                    size: -1,
                    sort: 'dateAnnounced'
                }
            });
        } catch (e) {
            debug.e('Error getting vendor incidents', e);
            return;
        }
        const incidentData = response.data.data;

        const augmentedIncidentData = incidentData.map((incident) => {
            const announcedDate = getDateTime({
                date: incident.dateAnnounced,
                noTimeString: true
            });
            return {
                ...incident,
                name: `
            ${announcedDate}: ${incident.application.name} (${incident.nistId})
        `
            };
        });

        setObjectPayload(augmentedIncidentData);
        setLoaded(true);
    };

    const [loaded, setLoaded] = useState(false);
    const [objectPayload, setObjectPayload] = useState([]);

    useEffect(() => {
        async function fetchData() {
            await loadIncidents({ setLoaded, setObjectPayload });
        }
        fetchData();
    }, []);

    return (
        loaded && (
            <ObjectPicker
                {...props}
                objectPayload={objectPayload}
                objectNameField="name"
            />
        )
    );
};

export default BreachPicker;
